import React, { useState, forwardRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import { NekoBusyOverlay, postFetch } from '../../index';

const StyledUploadDropArea = Styled.div`
  &.dropping {
    background: #a4d5ff;
  }
`;

const NekoUploadDropArea = forwardRef((props, ref) => {

  const { onSuccess = () => {}, onFailure = () => {}, apiUrl, apiConfig, className, disabled = false, children, multiple, ...rest } = props;
  const [ inDropZone, setInDropZone ] = useState(false);
  const [ busy, setBusy ] = useState(false);

  const uploadFile = async (files) => {
    setBusy(true);
    const upload = async (file) => {
      apiConfig.file = file;
      return await postFetch(apiUrl, apiConfig);
    }
    const response = await Promise.all(files.map(async (file) => {
      return await upload(file);
    }))
    const successResponses = response.filter(v => v.success);
    const failerResponses = response.filter(v => !v.success);
    if (successResponses.length) {
      onSuccess(multiple ? successResponses : successResponses[0]);
    }
    if (failerResponses.length) {
      onFailure(multiple ? failerResponses : failerResponses[0]);
    }
    setBusy(false);
  }

  const onDragOver = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
  }, [disabled]);

  const onDragEnter = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (disabled) return;
    setInDropZone(true);
  }, [disabled]);

  const onDragLeave = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (disabled) return;
    setInDropZone(false);
  }, [disabled]);

  const onDrop = useCallback((e) => {
    if (disabled) return;
    const files = [...e.dataTransfer.files];
    uploadFiles(files, e);
  }, [disabled]);

  const onInputUpload = (e) => {
    const files = [...e.target.files];
    uploadFiles(files, e);
  }

  const uploadFiles = (files, e) => {
    e.preventDefault();
    e.stopPropagation();
    setInDropZone(false);
    // console.log(files);
    uploadFile(files);
  }

  return (
    <NekoBusyOverlay busy={busy}>
      <input type="file" accept="image/*" ref={ref} onChange={onInputUpload} style={{ display: 'none' }} multiple={multiple} />
      <StyledUploadDropArea className={`${className ? className : ''} ${inDropZone ? 'dropping' : ''}`}
        onDragOver={onDragOver} onDragEnter={onDragEnter} onDragLeave={onDragLeave} onDrop={onDrop} {...rest}>
        {children}
      </StyledUploadDropArea>
    </NekoBusyOverlay>
  );
});

NekoUploadDropArea.propTypes = {
  ref: PropTypes.ref,
  onSuccess : PropTypes.func,
  onFailure : PropTypes.func,
  apiUrl : PropTypes.string,
  apiConfig : PropTypes.object,
  disabled: PropTypes.bool
};

NekoUploadDropArea.defaultProps = {
  onSuccess : () => {},
  onFailure : () => {},
  disabled : false
};

export { NekoUploadDropArea };
